import { SVG, SVGProps } from './svg'

export function IconLayout1h3v(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 16 16">
      <path d="M0 4c0-.6.4-1 1-1h14a1 1 0 110 2H1a1 1 0 01-1-1zM0 8c0-.6.4-1 1-1h14a1 1 0 110 2H1a1 1 0 01-1-1zM0 12c0-.6.4-1 1-1h14a1 1 0 110 2H1a1 1 0 01-1-1z" />
    </SVG>
  )
}
